module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_red_02-e0f1a9d43bd868731dd7c5160375849c.svg";